import ModelState from 'spa/state/_util/model';

class WorkerPromotedReviewsState extends ModelState {
  get method() { return 'GET'; }
  get url() { return '/workers'; }
  get subUrl() { return 'reviews/promoted'; }
  get singular() { return 'reviews'; }
  get plural() { return 'reviews'; }

  getSingleRequest(model) {
    if (!this.url) {
      throw new Error('Missing option `url`');
    }

    if (!this.subUrl) {
      throw new Error('Missing option `subUrl`');
    }

    if (!this.singular) {
      throw new Error('Missing option `singular`');
    }

    return this.ctx.sdk.get(`${this.url}/${model.id}/${this.subUrl}`);
  }
}

export default WorkerPromotedReviewsState;



// WEBPACK FOOTER //
// ./spa/state/worker-promoted-reviews.jsx